/**
 * Copyright 2019 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { type MutableRefObject, useEffect } from 'react';
import scrollToElem from '../utils/crossBrowserHelpers/scroll';
type Props = {
  ref: MutableRefObject<HTMLElement | null>;
  dependencies: unknown[];
  conditions?: boolean;
  afterScroll?: () => void;
  scrollOffset?: number;
};

export const useScrollToRef = ({
  ref,
  dependencies,
  conditions = false,
  afterScroll,
  scrollOffset = 80,
}: Props) => {
  useEffect(() => {
    if (ref.current && conditions) {
      const top = ref.current.offsetTop - scrollOffset;
      scrollToElem(top);
      afterScroll?.();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref, ...dependencies]);
};
